angular.module("ui2.0Controllers").controller("linkRedirectController", ['$scope', '$http', function ($scope,$http) {
    $scope.generatePostTokenUrl = function (paramsString) {
        // Get all query parameters from the URL after '#'
        const urlParams = new URLSearchParams(paramsString);

        // Build the query string dynamically
        let queryArr = [];
        for (const [key, value] of urlParams.entries()) {
            queryArr.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
        // Return the full postToken URL
        return `/esign/client/setup?${queryArr.join("&")}`;
    }
    
    
    $scope.processInitLinkCallback = function () {
        startLoader(); 
        const paramsString = window.location.href.split("#")[1]?.split("?")[1] || "";
        const urlParams = new URLSearchParams(paramsString);
        const state = urlParams.get("state");
        const entityId = state.split("_")[0];
        const entityName = entityId.replace(/\d+/g, "");
        const showPageUrl = window.CodeToURLPartMapping[entityName]

        const redirectShowPageUrl = `${window.location.href.split("/redirect")[0]}/show/${showPageUrl}/${entityId}`;
        const postToken = $scope.generatePostTokenUrl(paramsString);

        // Send authentication details to the backend
        $http.post(postToken)
            .then(function (response) {
                if(!response.data?.success){
                    SirionUtils.openSirionDialogs({popupType: 'alert', str: response.data.message, heading: intl_msg[24153], closeCallBack: () => {
                        window.location.href = redirectShowPageUrl;
                    }});
                } else {
                    window.location.href = redirectShowPageUrl;
                }  
            })
            .catch(function (error) {
                SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[28867], heading: intl_msg[24153], closeCallBack: () => {
                    window.location.href = redirectShowPageUrl;
                }});
            });
    };

    $scope.initLinkRedirect = function () {
        $scope.processInitLinkCallback();
    };
}]);